import { render } from "./synthesePdf.vue?vue&type=template&id=77615c66&scoped=true"
import script from "./synthesePdf.vue?vue&type=script&lang=js"
export * from "./synthesePdf.vue?vue&type=script&lang=js"

import "./synthesePdf.vue?vue&type=style&index=0&id=77615c66&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77615c66"]])

export default __exports__